import React from 'react'
import {Image} from 'cloudinary-react'
import Measure from 'react-measure'
import Icon from '../../misc/Icons.js'
  

class ImageWrapper extends React.Component{

	constructor(props){
		super(props)
		this.onImgLoad=this.onImgLoad.bind(this)
		this.onTempImgLoad=this.onTempImgLoad.bind(this)
		this.handleDoubleClick=this.handleDoubleClick.bind(this)
		this.state={			
			imageLoaded:false,
			tempImage:props.tempImage
		}
	}	
	

	sizeChanged(dimensions){
		const height=dimensions.dimensions.height /this.props.transformScale
		this.setState({imageContainerHeight:height})	
	}



	UNSAFE_componentWillReceiveProps(nextProps){
		this.setState({tempImage:nextProps.tempImage})
		if(nextProps.image!== this.props.image ){
			this.setState({imageLoaded:false})
		}
	}


	onImgLoad({target:img}) {
		this.setState({
			imageLoaded:true,
			imageNaturalHeight: img.naturalHeight,
			imageNaturalWidth: img.naturalWidth,
		})	
	}

	onTempImgLoad({target:img}) {
		this.setState({
			imageNaturalHeight: img.naturalHeight,
			imageNaturalWidth: img.naturalWidth,
		})	
	}


	handleDoubleClick(){
		if(!this.props.disableImageSearch){
			this.props.showImageSearchModal()
		}
	}


	render(){	
		const {uploadingToCloudinary,image, template, transformScale,isViewOnly}=this.props
		const {imageLoaded,tempImage,imageNaturalWidth, imageNaturalHeight}=this.state

		let imageWidth = 0
	 	let imageHeight = 0 

	 	let imageContainerWidth = 0
	 	let imageContainerHeight = 0

	 	if(template !== 'BodyCenterImageCenter'){
			imageContainerWidth = 580 
	 		imageContainerHeight = 680
	 	}
	 	else if(template === 'BodyCenterImageCenter' && image){
	 		imageContainerHeight = this.state.imageContainerHeight
	 		imageContainerWidth = 1160
	 	}
	 		
		// FOR FINDING IMAGE SIZE       
		let imageContainerAspectRatio = 0

		const imageNaturalAspectRatio = imageNaturalWidth / imageNaturalHeight

		imageContainerAspectRatio = imageContainerWidth / imageContainerHeight
    
		if(imageNaturalAspectRatio < imageContainerAspectRatio){	
			imageHeight = imageContainerHeight
			imageWidth = imageContainerHeight * imageNaturalAspectRatio
		}

		// WIDE IMAGE
		else {
			imageHeight = imageContainerWidth / imageNaturalAspectRatio
			imageWidth = imageContainerWidth
		}

		//

		let imageStyle={'visibility':'hidden' } //only show the real image once it has loaded, show the temp untill then
		if(!tempImage || (imageLoaded && !uploadingToCloudinary)){
			imageStyle={}
		 }

		
		return(		
			<div className="slide-imageContainer" >

				{(tempImage || imageLoaded) &&
					<div style={{height: `${imageHeight}px`, width: `${imageWidth}px`, minWidth: `calc((32px * ${1/transformScale}) + 20px)`, minHeight: `calc((32px * ${1/transformScale}) + 20px)`}} 
						onDoubleClick={this.handleDoubleClick}
						className='slide-imageContainer-imageControlsContainer'>
						<div className='slide-imageContainer-imageControls'>

							{uploadingToCloudinary &&
								<div style={{transform: `scale(${1/transformScale}`, transformOrigin: 'top left'}} 
									className='slide-imageContainer-imageControls-uploadingSpinner'>
									<div className='slide-imageContainer-imageControls-uploadingSpinner-spinner' />
								</div>
							}
							
							{imageLoaded && !isViewOnly &&																	
								<button style={{transform: `scale(${1/transformScale}`, transformOrigin: 'top right'}} className='slide-imageContainer-imageControls-removeImage' onClick={() =>{this.props.deleteImage()}}>
									<Icon name='close' />
								</button>									
							}								
						</div>
					</div>
				}					

				{uploadingToCloudinary && tempImage &&
					<img src={tempImage} id='formTempImage' alt='' onLoad={this.onTempImgLoad}/>
				}

				{tempImage && !imageLoaded && !uploadingToCloudinary &&
					<img src={tempImage} id='formTempImage' alt='' />
				}
				
				{template === 'BodyCenterImageCenter' && imageLoaded &&
					<Measure onMeasure={(dimensions) => {this.sizeChanged({dimensions})}}>
						<div className='slide-imageContainer-specialMeasurer'/>
					</Measure>
				}

				{image &&
						<Image						
							cloudName={process.env.REACT_APP_CLOUDINARY_CLOUDNAME}
							publicId={image===''?null:image}   
							responsive
							dpr='auto'							
    						width= '900' 
    						height='900'
    						crop= 'limit'                                
							role='presentation' 
							id='formImage'  
							style={imageStyle }  
							onLoad={this.onImgLoad}                                                         
						/>

						
				}		
			</div>		
		)
	}	
}


export default ImageWrapper











// WEBPACK FOOTER //
// ./src/components/slides/slideWrappers/ImageWrapper.js